<template>
    <LayCenter>
        <div slot="content">
            <a-carousel autoplay>
                <div
                        slot="prevArrow"
                        class="custom-slick-arrow"
                        style="left: 10px;zIndex: 1"
                >
                    <a-icon type="left-circle" />
                </div>
                <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                    <a-icon type="right-circle" />
                </div>
                <template v-for="topic in topics">
                    <Banner :key="topic.topicId" :style="{height: '243px'}" :topic="topic"/>
                </template>

                <!--<img height="243" src="https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/4fcc8a6694c9fb1d312ab4628d416803.png_target"/>
                <img height="243" src="https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/642d846cf0c10f21cf8540ddaca2fdf7.png_target"/>
                <img height="243" src="https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/e009f06b584de52c8205c004bc96574e.png_target"/>
                <img height="243" src="https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/523f4c80ca70d116742cd0881f05fad7.png_target"/>
                <img height="243" src="https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/3bf67cb5ad0cc38304215bfc7ec52e24.png_target"/>
                <img height="243" src="https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/0c0fdb59103deff3eff6547d9a91ee64.png_target"/>-->
            </a-carousel>
            <a-list itemLayout="vertical" :dataSource="data" :style="{marginBottom:'50px'}">
                <a-list-item slot="renderItem" slot-scope="item, index">
                    <template v-if="! loading">
                        <template  slot="actions">
                            <span :key="index">
                              <a-icon type="star-o" style="margin-right: 8px" />
                              {{item.interaction.favorite}}
                            </span>
                            <span :key="index">
                              <a-icon type="like-o" style="margin-right: 8px" />
                              {{item.interaction.like}}
                            </span>
                            <span :key="index">
                              <a-icon type="eye-o" style="margin-right: 8px" />
                              {{item.interaction.browse}}
                            </span>
                            <span :key="index">
                                {{item.gmtCreate}}
                            </span>
                        </template>
                    </template>
                    <img
                            v-if="! loading"
                            slot="extra"
                            width="242"
                            height="150"
                            alt="logo"
                            :src="item.coverImg ? item.coverImg : 'https://picker-oss.oss-cn-beijing.aliyuncs.com/meta/grasswort.png_target'"
                    />
                    <a-skeleton :loading="loading"  avatar>
                        <a-list-item-meta :description="'作者：' + item.author">
                            <a slot="title">
                                <strong>
                                    <router-link :to="'/blog/' + item.blogId + '.html'" target="_blank"  :style="{'color':'unset'}" v-html="item.title"/>
                                </strong>
                                <template v-for="(tag, index) in item.labels">
                                    <a-tag :style="{'margin-left': '5px', 'margin-right': '-2px'}" :key="tag" :color="tagColors[index % tagColors.length]">{{ tag }}</a-tag>
                                </template>
                            </a>
                            <a-avatar slot="avatar" :src="item.authorAvatar"/>
                        </a-list-item-meta>
                    </a-skeleton>
                    <span v-if="! loading" v-html="item.summary"></span>
                </a-list-item>
                <div
                        v-if="showLoadingMore"
                        slot="loadMore"
                        :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
                >
                    <a-spin v-if="loadingMore" />
                    <a-button v-else id="blog_pool_load_more_btn">加载更多数据</a-button>
                </div>
            </a-list>
        </div>
    </LayCenter>
</template>
<script>
    import LayCenter from "@/components/layout/LayCenter";
    import { BLOG_POOL_GET } from "@/components/constant/url_path";
    import { BANNER_1, BANNER_2, BANNER_3, BANNER_4 } from "../constant/banner_img";
    import Banner from "../banner/Banner";

    /**
     * 判断某个元素是否在可视区域
     * @param element
     * @returns {boolean}
     */
    function inViewArea(element) {
        let windowHeight = window.innerHeight;
        let rect = element.getBoundingClientRect();
        let top = rect.top;
        let bottom = rect.bottom;
        let isTopInWindow = 0 < top && top < windowHeight;
        let isBottomInWindow = 0 < bottom && bottom <= windowHeight;
        return isTopInWindow || isBottomInWindow;
    }

    export default {
        components: {
            Banner,
            LayCenter
        },
        data() {
            return {
                data:[{title: ''},{title: ''},{title: ''},{title: ''},{title: ''},{title: ''}],
                topics: [
                    {
                        title: '采采卷耳',
                        author: '散落一地王侯',
                        topicId: '47cc7f1daa52bc9c',
                        image: BANNER_1,
                        summary: 'Picker 网站功能简介以及操作指引。'
                    },
                    {
                        title: '设计模式',
                        author: '散落一地王侯',
                        topicId: '6bc13622c90e52f9',
                        image: BANNER_4,
                        summary: 'Java 23 种设计模式。'
                    },
                    {
                        title: 'Spring Cloud Quick Start',
                        author: '散落一地王侯',
                        topicId: '0633755146361c16',
                        image: BANNER_3,
                        summary: 'Spring Cloud 学习记录。为 Spring Cloud 部分功能特性做一些简单的 Demo 实现。'
                    }
                ],
                isSkeleton: true,
                loading: true,
                showLoadingMore: false,
                loadingMore: false,
                /*tagColors:[  'red', 'purple', 'cyan', 'orange', 'blue',  'green', 'pink']*/
                tagColors:['cyan'],
                pageNo: 0,
                pageSize: 10
            };
        },
        mounted: function () {
            let _this = this;
            _this.fetchData();
            document.addEventListener('scroll', _this.scrollEvent)
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.scrollEvent);
        },
        methods: {
            fetchData() {
                let _this = this;
                _this.pageNo += 1;
                _this.loadingMore = true;
                _this.$axios.get(BLOG_POOL_GET+"?pageNo=" + _this.pageNo + "&pageSize=" + _this.pageSize).then(function (response) {
                    _this.loadingMore = false;
                    let code = response.data.code;
                    if (code == 200) {
                        if (_this.isSkeleton) {
                            _this.data = response.data.result;
                            _this.isSkeleton = false;
                        } else {
                            for (let i = 0; i < response.data.result.length; i++) {
                                _this.data.push(response.data.result[i]);
                            }
                        }
                        _this.loading = false;
                        _this.showLoadingMore = response.data.total > ((_this.pageNo - 1) * _this.pageSize + response.data.result.length);
                    }
                }).catch(function () {
                    _this.loadingMore = false;
                    _this.$message.warn("当前网络不稳定，请稍后重试。");
                })
            },
            scrollEvent() {
                let loadMoreBtn = document.getElementById("blog_pool_load_more_btn");
                if (loadMoreBtn != undefined) {
                    let loadMore = inViewArea(loadMoreBtn);
                    if (loadMore) {
                        this.fetchData();
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .skeleton-demo {
        border: 1px solid #f4f4f4;
    }
    .ant-carousel >>> .slick-slide {
        text-align: center;
        height: 240px;
        line-height: 240px;
        background: #364d79;
        overflow: hidden;
        margin-bottom: 30px;
    }

    .ant-carousel >>> .slick-slide h3 {
        color: #fff;
    }

    .ant-carousel >>> .custom-slick-arrow {
        width: 25px;
        height: 25px;
        font-size: 25px;
        color: #fff;
        background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.3;
    }
    .ant-carousel >>> .custom-slick-arrow:before {
        display: none;
    }
    .ant-carousel >>> .custom-slick-arrow:hover {
        opacity: 0.5;
    }

</style>
